// AUTO-GENERATED by scripts/generate-cn-theme.mjs from src/styles/theme.css — do not edit by hand.
// Regenerated automatically by `pnpm dev`, `pnpm build`, and `pnpm typecheck` (via pre-hooks), or
// manually via `pnpm --filter @commercial-website/ui generate:cn-theme`.
export const cnThemeExtend = {
    text: [
        'dep-xxs',
        'dep-xs',
        'dep-sm',
        'dep-md',
        'dep-lg',
        'dep-xl',
        'dep-xxl',
        'heading-5xl',
        'heading-4xl',
        'heading-3xl',
        'heading-2xl',
        'heading-xl',
        'heading-l',
        'heading-m',
        'heading-s',
        'body-l',
        'body-m',
        'body-s',
        'label-3xl-display',
        'label-2xl-display',
        'label-l',
        'label-m',
        'label-s',
        'label-l-strong',
        'label-m-strong',
        'label-s-strong',
        'link-xl',
        'link-l',
        'link-s',
        'subline-xl',
        'subline-m',
    ],
    radius: [
        'dep-2',
        'dep-4',
        'dep-8',
        'dep-12',
        'dep-20',
        'dep-full',
        '4',
        '8',
        '12',
        '16',
        '20',
        'full',
        'circle',
    ],
    shadow: ['dep-elevate-quiet', 'dep-raise-quiet'],
    leading: ['dep-xxs', 'dep-xs', 'dep-sm', 'dep-md', 'dep-lg', 'dep-xl', 'dep-xxl'],
    ease: ['linear', 'slide', 'menu'],
};
